module.exports = __webpack_public_path__ + "img/percentage-icon.3db7bbe1.svg";